import React from "react"
import { Dialog, FlatButton, SelectField, MenuItem } from "material-ui"
import strings from "../../../localization/strings"
import autobind from "class-autobind"
import { ENotifyMethods } from "../../../models"
import { EnumValues } from "enum-values"
interface IProps {
  existingNotifyMethods: ENotifyMethods[]
  handleSave(notifyMethods: ENotifyMethods): void
  handleClose(): void
}
interface IState {
  notifyMethod: ENotifyMethods
  errorNotifyMethod: string
}

export default class AddNotifyMethodDialog extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)
    this.state = {
      notifyMethod: null,
      errorNotifyMethod: ""
    }
    autobind(this)
  }

  checkValidate() {
    let isValidate = true
    if (!this.state.notifyMethod) {
      this.setState({ errorNotifyMethod: strings.This_field_is_required })
      isValidate = false
    }
    else {
      this.setState({ errorNotifyMethod: "" })
    }
    return isValidate
  }

  handleSave() {
    if (!this.checkValidate()) return
    this.props.handleSave(this.state.notifyMethod)
  }

  render() {
    return (
      <Dialog
        open
        title={strings.Add_Notify_Method}
        titleStyle={{ paddingLeft: 35, paddingBottom: 10 }}
        actions={
          <div>
            <FlatButton
              label={strings.CANCEL}
              secondary={true}
              onTouchTap={this.props.handleClose}
            />
            <FlatButton
              label={strings.SAVE}
              primary={true}
              onTouchTap={this.handleSave}
            />
          </div>
        }
      >
        <hr />
        <div style={{ paddingLeft: 15, paddingRight: 15 }}>
          <SelectField
            floatingLabelText={strings.Notify_Method}
            value={this.state.notifyMethod}
            onChange={(e, key, payload) => this.setState({ notifyMethod: payload }, () => this.checkValidate())}
            errorText={this.state.errorNotifyMethod}
            errorStyle={{ position: "absolute", top: 70 }}
          >
            {EnumValues.getValues(ENotifyMethods)
              .filter(item => item !== ENotifyMethods.App && !this.props.existingNotifyMethods.includes(item as ENotifyMethods))
              .map((item, index) =>
                <MenuItem
                  key={index}
                  value={item}
                  primaryText={strings[item]}
                />
              )}
          </SelectField>
        </div>
      </Dialog>
    )
  }
}